import React, { useState, useEffect } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { X } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import defaultImage from "@/assets/founding-day.jpg";

const FOUNDING_DAY_KEY = "founding_day_2026_dismissed";

const FoundingDayPopup: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState(defaultImage);

  useEffect(() => {
    const dismissed = sessionStorage.getItem(FOUNDING_DAY_KEY);
    if (dismissed) return;

    const checkSetting = async () => {
      const { data } = await supabase
        .from("site_settings")
        .select("setting_value")
        .eq("setting_key", "founding_day_popup")
        .single();
      
      const settings = data?.setting_value as any;
      const enabled = settings?.enabled ?? true;
      if (!enabled) return;

      // Check expiry date
      if (settings?.expiry_date) {
        const expiry = new Date(settings.expiry_date);
        if (new Date() > expiry) return;
      }

      if (settings?.image_url) {
        setImageUrl(settings.image_url);
      }
      setTimeout(() => setOpen(true), 1000);
    };
    checkSetting();
  }, []);

  const handleClose = () => {
    setOpen(false);
    sessionStorage.setItem(FOUNDING_DAY_KEY, "true");
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) handleClose(); }}>
      <DialogContent className="sm:max-w-lg p-0 overflow-hidden border-0 bg-transparent shadow-2xl [&>button]:hidden">
        <div className="relative">
          <button
            onClick={handleClose}
            className="absolute top-3 left-3 z-10 bg-black/50 hover:bg-black/70 text-white rounded-full p-1.5 transition-colors"
            aria-label="إغلاق"
          >
            <X className="h-5 w-5" />
          </button>
          <img
            src={imageUrl}
            alt="يوم التأسيس - يوم بدينا - ثلاثة قرون من العز والفخر"
            className="w-full h-auto rounded-lg"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FoundingDayPopup;
